import PartsSelection from 'pages/CatalogPage/DH/SubcategorySection/OperationsSection/PartsSelection/PartsSelection';

export default PartsSelection;
